import {Action} from "@ngrx/store";
import {WooCommerceSettings} from "../../websites/website/ecommerce/ecommerce-settings/ecommerce-settings.interface";

export const LOAD_ECOMMERCE_SETTINGS: string = '[ecommerce settings] Load Ecommerce Settings';
export const LOAD_ECOMMERCE_SETTINGS_SUCCESS: string = '[ecommerce settings] Load Ecommerce Settings Success';
export const LOAD_ECOMMERCE_SETTINGS_FAIL: string = '[ecommerce settings] Load Ecommerce Settings Fail';

export class LoadEcommerceSettings implements Action {
  readonly type: string = LOAD_ECOMMERCE_SETTINGS;

  constructor(public payload: { websiteId: number }) {
  }
}

export class LoadEcommerceSettingsSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_SETTINGS_SUCCESS;

  constructor(public payload: {
    settings: WooCommerceSettings,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommerceSettingsFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_SETTINGS_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommerceSettingsAction = LoadEcommerceSettings | LoadEcommerceSettingsSuccess | LoadEcommerceSettingsFail;
